import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Card from "@react/shared/ui/Card"

const StatsStrip = ({ stats }) => {
  if (!stats) return null

  const cells = [
    {
      label: I18n.t("mbc_contracts.status.active",   { defaultValue: "Actif" }),
      value: String(stats.active_count ?? 0),
      icon:  "circle-play",
    },
    {
      label: I18n.t("mbc_contracts.status.draft",    { defaultValue: "Brouillon" }),
      value: String(stats.draft_count ?? 0),
      icon:  "pen-ruler",
    },
    {
      label: I18n.t("mbc_contracts.status.inactive", { defaultValue: "Inactif" }),
      value: String(stats.inactive_count ?? 0),
      icon:  "circle-pause",
    },
  ]

  return (
    <div className="grid grid-cols-3 gap-3 mb-6">
      {cells.map(cell => (
        <Card key={cell.label} padding="md" className="rounded-lg">
          <div className="flex items-center justify-between">
            <div className="text-xs text-slate-500">{cell.label}</div>
            <FontAwesomeIcon icon={cell.icon} className="text-slate-400 text-[13px]" />
          </div>
          <div className="text-2xl font-semibold text-slate-900 tabular-nums mt-2">
            {cell.value}
          </div>
        </Card>
      ))}
    </div>
  )
}

export default StatsStrip
